import { Outlet, useParams } from 'react-router-dom';
import Content from '../../../components/content';
import { PhysicianDto } from '../../../lib/ServerApi';
import { api } from '../../../lib/api';
import { useQuery } from '@tanstack/react-query';

export function PhysiciansLayout() {
    const params = useParams<'physicianId'>();

    const { data } = useQuery<PhysicianDto>({
        queryKey: ['physician', params.physicianId],
        queryFn: async () => {
            const { data } = await api.physician.get(params.physicianId as string);
            return data;
        },
        enabled: Boolean(params.physicianId),
    });

    return (
        <Content
            headerTitle={data ? `${data.firstName} ${data.lastName} ${data?.credential || ''}` : 'Physicians'}
            backNavLink={params.physicianId ? '/settings/physicians' : '/settings'}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
